/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

export const Screen = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CheckYourEmail = styled.div`
  padding: 24px 32px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  display: inline-flex;
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 24px;
`;

export const FirstSection = styled.div`
  flex-direction: column;
  align-items: center;
  gap: 16px;
  display: inline-flex;
`;

export const CheckYourEmailSpan = styled.span`
  color: #e9ecf5;
  font-size: 21px;
  font-family: Inter;
  font-weight: 500;
  line-height: 25.2px;
  word-wrap: break-word;
  text-align: center;
`;

export const FirstSectionParagraph = styled.span`
  color: #b7bdcb;
  font-size: 16px;
  font-family: Inter;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
  text-align: center;
`;
